const ForgotPasswordURL = (currentLanguage) => {
  if (currentLanguage.includes('fr_')){
    return "https://www.annatel.co.il/fr_FR/forgotpassword"
  }

  if (currentLanguage.includes('en_')){
    return "https://www.annatel.us/en_US/forgotpassword"
  }

  return "https://www.annatel.co.il/fr_FR/forgotpassword"
}
export default ForgotPasswordURL;



// WEBPACK FOOTER //
// ./src/localeAssets/ForgotPasswordURL.js